import React from 'react';

export interface AccessDeniedPanelProps {
  title?: string;
  message: React.ReactNode;
  className?: string;
}

/**
 * Access-denied state — shared across module pages.
 */
const AccessDeniedPanel: React.FC<AccessDeniedPanelProps> = ({
  title = 'Access Denied',
  message,
  className,
}) => {
  return (
    <div className={`flex min-h-[24rem] items-center justify-center ${className ?? ''}`}>
      <div className="text-center">
        <p className="text-lg font-semibold text-destructive">{title}</p>
        <p className="mt-2 text-muted-foreground">{message}</p>
      </div>
    </div>
  );
};

export default AccessDeniedPanel;
